import { suffix } from './suffix'

export const actionTypes = (prefix) => ({
  entity: `${prefix}/${suffix.entity}`,
  update: `${prefix}/${suffix.update}`,
  create: `${prefix}/${suffix.create}`,
  saving: `${prefix}/${suffix.saving}`,
  saved: `${prefix}/${suffix.saved}`,
  deleting: `${prefix}/${suffix.deleting}`,
  deleted: `${prefix}/${suffix.deleted}`,
  restoring: `${prefix}/${suffix.restoring}`,
  restored: `${prefix}/${suffix.restored}`,
  refresh: `${prefix}/${suffix.refresh}`,
  error: `${prefix}/${suffix.error}`
})

export const lookupActionTypes = (prefix) => ({
  entity: `${prefix}/${suffix.entity}`
})